export const INQ_STATUS = [
  { v: "new", label: "New", cls: "bg-[#C4832B] text-[#0A0A0C]" },
  { v: "contacted", label: "Contacted", cls: "bg-sky-500/15 text-sky-300" },
  { v: "proposal_sent", label: "Proposal sent", cls: "bg-amber-300/15 text-amber-200" },
  { v: "booked", label: "Booked", cls: "bg-emerald-500/15 text-emerald-300" },
  { v: "archived", label: "Archived", cls: "border border-[#2E2A24] text-zinc-400" },
];

export const inqStatus = (v) => INQ_STATUS.find((s) => s.v === v) ?? { v, label: v, cls: "border border-[#2E2A24] text-zinc-300" };
